<!--child.vue-->
<template>
  <div class="tips_wrap">
    <el-dialog
      :close-on-click-modal="false"
      title="微信扫码支付"
      :visible.sync="dialogFormVisible"
      @close="closeDialog"
    >
      <el-form
        v-loading="loading"
        :model="ruleForm"
        ref="ruleForm"
        label-width="50rpx"
        class="demo-ruleForm"
      >
        <el-form-item label="" v-if="backUrl != ''">
          <div class="img">
            <img :src="backUrl" alt="" />
          </div>
        </el-form-item>

        <el-form-item label="充值金额" v-if="backUrl == ''">
          <el-input v-model="ruleForm.money"></el-input>
        </el-form-item>

        <el-form-item>
          <div style="text-align: right">
            <el-button type="primary" @click="submitForm()">确定</el-button>
          </div>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
export default {
  props: {
    dialogShow: {
      type: Boolean,
      default: false,
    },
  },
  mounted() {
    console.log("我是子组件");
  },

  data() {
    return {
      loading: false,
      backUrl: "",
      ruleForm: {
        money: 100,
        sysUserId: "",
      },
      dialogFormVisible: this.dialogShow,
    };
  },
  created() {
    this.ruleForm.sysUserId =this.$store.state.user.user.id
  },
  watch: {
    dialogShow(val) {
      this.dialogFormVisible = val;
    },
  },

  methods: {
    init(id) {
      var that = this;
      that.loading = true;
      this.$axios
        .post("/api2/user/findOneUser/", {
          id,
        })
        .then(function (response) {
          console.log(response.data);
          if (response.data.code == 200) {
            console.log(response.data.data);
            that.ruleForm = response.data.data;
          } else {
            that.$message.error(response.mes);
          }
          that.loading = false;
        });
    },
    submitForm() {
      var that = this;
      that.loading = true;
      this.$axios
        .post("/api2/pay/sacn", that.ruleForm)
        .then(function (response) {
          console.log(response.data);
          if (response.data.backUrl != "") {
            // that.$message({
            //   type: "success",
            //   message: "操作成功",
            // });
            that.backUrl =
              "https://www.165game.fun/api2/code/wxpay?content=" +
              response.data.backUrl;
              var count=0
             setInterval(function () {
            if(count<50){
              count++
            }else{
              return
            }
              that.$axios
                .get("/api2/pay/order/" + response.data.tradeNo, {})
                .then(function (response) {
                  if(response.data.code==200){
                    that.$emit('pushdata')
                    that.$emit("modelChange", false);
                    console.log(response.data)
                    return
                  }
                });
            }, 3000);
          } else {
            that.$message.error(response.data.mes);
          }
          that.loading = false;
        });
    },

    closeDialog() {
      this.$emit("modelChange", false);
    },
  },
};
</script>
<style  scoped>
.img {
  display: flex;
  justify-content: center;
  align-content: center;
}
</style>
